import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'User opened a canvas node tool, whether or not they completed it. Pairs with canvas_node_toolbar_action_clicked; do not sum the two events.',
  name: 'canvas_node_tool_opened',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The type of node the tool was opened on',
      name: 'node_type',
      required: true,
      type: 'enum',
      values: ['image', 'video'],
    },
    {
      description: 'The tool that was opened',
      name: 'action_taken',
      required: true,
      type: 'enum',
      values: [
        'adjust_image',
        'camera_angle',
        'camera_motion',
        'change_lighting',
        'smart_resize',
        'crop',
        'prompt',
        'edit_text',
        'flip_and_rotate',
        'erase',
        'extend_background',
        'remove_background',
        'upscale',
        'convert_to_gif',
        'animate',
        'extend_video',
        'vectorize',
        'translate',
        'split_elements',
        'add_border',
        'add_text',
        'combine_images',
        'download',
        'merge_layers',
        'save_as_version',
        'save_to_board',
        'add_solid_background',
        'stylize',
      ],
    },
    {
      description: 'Where the tool was launched from',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['toolbar', 'tools_menu', 'empty_state', 'tool_rail', 'next_action_pill'],
    },
    {
      description:
        'The 1-based place of this tool in the left-rail catalog. Prompt is 1. Pins and search do not change it. Omitted when the open is not from the left rail, or when the tool has no catalog tracking id.',
      name: 'rail_index',
      required: false,
      type: 'number',
    },
  ],
};

export default META;
